import http from "./httpService";

const endPoint = "/api/v1/Account";

export function getAcc(request) {
    return http.post(`${endPoint}`, request);
}

export default {getAcc};


// WEBPACK FOOTER //
// ./src/services/accountService.js